<template>
  <div class="mediaLibrary">
    <div class="mediaLibraryToolbar">
      <div class="mediaLibrarySearch">
        <base-input
          placeholder="Chercher un fichier"
          v-model="filterStr"
        >
        </base-input>
      </div>

      <div class="mediaLibraryToolbarActions">
        <div class="mediaLibraryCounter">{{ filteredList.length }} résultat<span v-if="filteredList.length > 1">s</span></div>
        <b-button
          variant="primary"
          class="mediaLibrarySelectBtn"
          @click="onSelect()"
          v-if="__payload.multiSelection && selectedItems.length>0"
        >
          <b-icon icon="check-square-fill"></b-icon>
          Sélectionner {{ selectedItems.length }}
        </b-button>
      </div>
    </div>

    <div v-if="filteredList.length === 0" class="mediaLibraryEmpty">
      <b-icon icon="folder2-open" class="mediaLibraryEmptyIcon"></b-icon>
      <div class="mediaLibraryEmptyTitle">Aucun fichier ne correspond à votre recherche</div>
      <div class="mediaLibraryEmptyHint">Essayez un autre mot-clé ou ajoutez un nouveau média dans ce dossier.</div>
    </div>

    <div v-else class="mediaLibraryGrid">
      <article
        v-for="item in filteredList"
        :key="item.delete_id || item.delete_url"
        class="mediaCard"
        :class="{ 'mediaCard-selected': selectedItems.includes(item.delete_url) }"
      >
        <button type="button" class="mediaCardPreview" @click="dispatchOnCliqueImg(item.delete_url)">
          <img :src="getTof(item.delete_url)" :alt="item.name" class="mediaCardImage">
        </button>

        <div class="mediaCardBody">
          <div class="mediaCardName" :title="item.name">{{ item.name }}</div>
          <div class="mediaCardMeta">{{ formatSize(item.size) }}</div>
        </div>

        <div class="mediaCardFooter">
          <base-button
            v-if="__payload.folderClientInfo.alowDelete"
            icon
            type="danger"
            size="sm"
            class="mediaCardAction mediaCardAction-danger"
            @click="dispatchDelete(item.delete_id)"
          >
            <b-icon icon="trash-fill"></b-icon>
          </base-button>

          <base-button
            icon
            type="info"
            size="sm"
            class="mediaCardAction"
            v-if="__payload.multiSelection && selectedItems.includes(item.delete_url)"
            @click="dispatchUnselect(item.delete_url)"
          >
            <b-icon icon="check-square-fill"></b-icon>
          </base-button>

          <base-button
            icon
            size="sm"
            type="info"
            class="mediaCardAction mediaCardAction-muted"
            v-if="__payload.multiSelection && !selectedItems.includes(item.delete_url)"
            @click="dispatchselect(item.delete_url)"
          >
            <b-icon icon="check-square"></b-icon>
          </base-button>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import { BaseButton } from '@/components';
export default {
  props: {
    __list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    __payload: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      selectedItems: [],
      filterStr: ""
    };
  },
  computed: {
    filteredList() {
      const query = this.filterStr.trim().toLowerCase();
      if (!query) {
        return this.__list;
      }

      return this.__list.filter((item) => String(item.name || '').toLowerCase().includes(query));
    },
  },
  methods: {
    getTof(c) {
      return c ? this.__.resolveMediaPath(c, "uploads/catalogue/No-Image.jpg") : '';
    },
    formatSize(sizeInKo = 0) {
      const value = Number(sizeInKo || 0);
      if (value >= 1024) {
        return `${(value / 1024).toFixed(2)} Mo`;
      }
      return `${value.toFixed(0)} Ko`;
    },
    dispatchselect(url) {
      this.selectedItems.push(url)
    },
    dispatchUnselect(url) {
      this.selectedItems = this.selectedItems.filter(e => e !== url)
    },

    dispatchOnCliqueImg(url) {
      if(!this.$props.__payload.multiSelection) {
        this.selectedItems[0] = url
        this.onSelect()
      } else {
        
      }
    },
    onSelect() {
      this.$props.__payload.onFireCB(this.selectedItems);
    },
    onDeleteAction(path, idx) {
      this.$props.__payload.onDelete(path, idx);
    },
    dispatchDelete(path, idx) {
      this.$bvModal.msgBoxConfirm('Veuillez confirmer la suppression.', {
        title: 'Confirmation',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Confirmer',
        cancelTitle: 'Annuler',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: false
      })
        .then(value => {
          if(value) {
            this.onDeleteAction(path, idx);
          }
        })
    },
  },
};
</script>
<style scoped>
.mediaLibrary {
  width: 100%;
}

.mediaLibraryToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 18px;
}

.mediaLibrarySearch {
  flex: 1 1 320px;
  max-width: 420px;
}

.mediaLibraryToolbarActions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.mediaLibraryCounter {
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.mediaLibrarySelectBtn {
  border-radius: 12px;
  font-weight: 700;
}

.mediaLibrarySelectBtn .b-icon {
  margin-right: 6px;
}

.mediaLibraryGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 14px;
}

.mediaCard {
  display: flex;
  flex-direction: column;
  min-width: 0;
  border-radius: 18px;
  border: 1px solid #dbe4f0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.mediaCard:hover {
  transform: translateY(-2px);
  border-color: #bfdbfe;
  box-shadow: 0 18px 28px rgba(15, 23, 42, 0.12);
}

.mediaCard-selected {
  border-color: #60a5fa;
  box-shadow: 0 18px 28px rgba(37, 99, 235, 0.16);
}

.mediaCardPreview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1 / 1;
  padding: 10px;
  border: 0;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  cursor: pointer;
}

.mediaCardImage {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.mediaCardBody {
  padding: 12px 12px 8px;
}

.mediaCardName {
  min-height: 34px;
  margin-bottom: 6px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  word-break: break-word;
}

.mediaCardMeta {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
}

.mediaCardFooter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px 12px;
}

.mediaCardAction {
  margin-left: 0 !important;
}

.mediaCardAction-muted {
  background-color: #64748b !important;
  background-image: none !important;
  border-color: #64748b !important;
}

.mediaLibraryEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 18px;
  border-radius: 20px;
  border: 1px dashed #cbd5e1;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  text-align: center;
}

.mediaLibraryEmptyIcon {
  margin-bottom: 12px;
  color: #94a3b8;
  font-size: 2rem;
}

.mediaLibraryEmptyTitle {
  margin-bottom: 6px;
  color: #334155;
  font-size: 16px;
  font-weight: 700;
}

.mediaLibraryEmptyHint {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

@media (max-width: 767px) {
  .mediaLibraryToolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .mediaLibrarySearch {
    max-width: none;
  }

  .mediaLibraryToolbarActions {
    justify-content: space-between;
  }

  .mediaLibraryGrid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
  }
}
</style>
